
function setupPerPage () {
  var itemsPerPage = $('.custom-select-radios.pages input:checked').val();
  $('.custom-select-radios.pages button')
    .text(itemsPerPage + ' per page');
}

$(document).ready(function() {

  if ($('.table.profiles-table')) {
    setupPerPage();
  }

});
